import {
  faClipboardList,
  faChartBar,
  faCog,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';

export const DASHBOARD_ROUTES = {
  STAFF: '/staff',
  ITEMS: '/items',
  CUSTOMIZATIONS: '/customizations',
  MENU: '/menu',
  ANALYTICS: '/sales-analytics',
  REPORTS: '/reports',
  ORDERS: '/orders',
  SETTINGS: '/settings',
} as const;

export const METRIC_TYPES = {
  STAFF: 'totalStaff',
  ITEMS: 'items',
  CUSTOMIZATIONS: 'customizations',
  DAILY_OPERATIONS: 'dailyOperations',
} as const;

export const SECTION_TITLES = {
  STAFF: 'Total Staff',
  ITEMS: 'Items',
  CUSTOMIZATIONS: 'Customizations',
  DAILY_OPERATIONS: 'Daily Operations',
  QUICK_ACTIONS: 'Quick Actions',
  ALERTS: 'Alerts & Warnings',
  RECENT_ACTIVITY: 'Recent Activity',
} as const;

export const BUTTON_LABELS = {
  VIEW_ALL_STAFF: 'View All Staff',
  VIEW_ALL_ITEMS: 'View All Items',
  VIEW_ALL_CUSTOMIZATIONS: 'View All Customizations',
  VIEW_MENU: 'View Menu',
  ADD_NEW_ITEM: 'Add New Item',
  MANAGE_CUSTOMIZATIONS: 'Manage Customizations',
  VIEW_SOLD_OUT: 'View Sold Out Items',
  VIEW_ORDERS: 'View Orders',
  REFRESH: 'Refresh',
} as const;

export const QUICK_ACTIONS_CONFIG = [
  {
    key: 'menu',
    label: 'Menu',
    icon: faClipboardList,
    route: DASHBOARD_ROUTES.MENU,
    color: '#2D6CCA',
  },
  {
    key: 'items',
    label: 'Items',
    icon: faChartBar,
    route: DASHBOARD_ROUTES.ITEMS,
    color: '#48BB78',
  },
  {
    key: 'customizations',
    label: 'Customizations',
    icon: faCog,
    route: DASHBOARD_ROUTES.CUSTOMIZATIONS,
    color: '#ED8936',
  },
  {
    key: 'analytics',
    label: 'Analytics',
    icon: faChartBar,
    route: DASHBOARD_ROUTES.ANALYTICS,
    color: '#9F7AEA',
  },
  {
    key: 'reports',
    label: 'Reports',
    icon: faFileAlt,
    route: DASHBOARD_ROUTES.REPORTS,
    color: '#F56565',
  },
] as const;
